export default {
  setHome: (state, payload) => {
    state.home = payload;
  },
};
